<template>
    <div class="service">
        <mt-header fixed title="服务记录">
            <router-link :to="backurl" slot="left">
                <mt-button icon="back">返回</mt-button>
            </router-link>
        </mt-header>
        <div class="elder-form">
            <div class="service-header">
                <div class="service-header-info">
                    <div class="service-header-img">
                        <img :src="'../../static/'+service_img+'.png'" />
                    </div>
                    <div class="service-header-text">
                        {{ service }}
                    </div>
                </div>
            </div>
            <div class="service-body">
                <mt-field label="*服务对象" v-model="elderName" disabled v-if="big_type==='single'"></mt-field>
                <mt-field label="*主题" placeholder="请输入主题" v-model="title"></mt-field>

                <a class="mint-cell mint-field"><!---->
                    <div class="mint-cell-left"></div>
                    <div class="mint-cell-wrapper">
                        <div class="mint-cell-title"><!---->
                            <span class="mint-cell-text">*服务时间</span><!---->
                        </div>
                        <div class="mint-cell-value">
                            <input placeholder="请输入服务时间" readonly @click="open('datatimePicker')" v-model="carry_time"
                                class="mint-field-core">
                            <mt-datetime-picker ref="datatimePicker" v-model="carry_time_hide" year-format="{value} 年"
                                month-format="{value} 月" date-format="{value} 日" hour-format="{value} 时"
                                minute-format="{value} 分" second-format="" @confirm="handleConfirm"
                                @cancel="handleCancel"></mt-datetime-picker>
                        </div> <!---->
                    </div>
                    <div class="mint-cell-right"></div>
                </a>

                <mt-field label="*参与人数" placeholder="请输入活动参与人数" type="number" v-model="activity_number"
                    v-if="big_type==='group'"></mt-field>

                <mt-field label="同行人员" placeholder="请输入同行人员" v-model="other_staff"></mt-field>
                <mt-field label="*服务简述" placeholder="请输入服务简述" type="textarea" rows="3" v-model="desc"></mt-field>
                <div class="mint-checklist">
                    <label class="mint-checklist-title">服务图片</label>
                    <uploader @getFiles='getImageList' @removeFiles='removeImage'></uploader>
                </div>
                <div class="mint-checklist" v-if="big_type==='group'">
                    <label class="mint-checklist-title">签到记录</label>
                    <uploader @getFiles='getImageList2' @removeFiles='removeImage2'></uploader>
                </div>

                <mint-select selectLabel="*身体情况" selectPatch="body_condition" :selectValue="body_condition"
                    :slots="body_condition_options" @changeValue="changeValue" v-if="type === '入户'"></mint-select>

                <mint-select selectLabel="*精神状态" selectPatch="mental_condition" :selectValue="mental_condition"
                    :slots="mental_condition_options" @changeValue="changeValue" v-if="type === '入户'"></mint-select>

                <mint-select selectLabel="*生活状况" selectPatch="living_condition" :selectValue="living_condition"
                    :slots="living_condition_options" @changeValue="changeValue" v-if="type === '入户'"></mint-select>

                <mint-select selectLabel="*社会支持情况" selectPatch="social_condition" :selectValue="social_condition"
                    :slots="social_condition_options" @changeValue="changeValue" v-if="type === '入户'"></mint-select>


                <!--  <mt-field label="*身体情况" placeholder="请输入身体情况" type="textarea" rows="3"
                    v-model="body_condition"></mt-field> -->
                <!--       <mt-field label="*精神状态" placeholder="请输入精神状态" type="textarea" rows="3"
                    v-model="mental_condition"></mt-field>
                <mt-field label="*生活状况" placeholder="请输入生活状况" type="textarea" rows="3"
                    v-model="living_condition"></mt-field>
                <mt-field label="*社会支持情况" placeholder="请输入社会支持情况" type="textarea" rows="3"
                    v-model="social_condition"></mt-field>-->
                <mt-field label="*其他需求" placeholder="请输入其他需求" type="textarea" rows="3" v-model="demand"
                    v-if="type === '入户'"></mt-field>

                <mt-field label="*定位地址" v-model="location" disabled></mt-field>
                <div class="new-form-button">
                    <mt-button size="large" type="primary" @click="updateService">提交</mt-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import uploader from "../components/upload"
    import { DatetimePicker } from 'mint-ui'
    import mintSelect from '../components/mintSelect.vue'

    import wx from 'weixin-js-sdk'
    let moment = require("moment")

    export default{

        components: {
            uploader,
            mintSelect
        },

        data(){
            return {
                type: this.$route.query.type,
                big_type:'single',

                backurl:'/service/'+this.$route.query.type,

                service_img:'care',
                service:this.$route.query.type,
                openid:JSON.parse(window.localStorage.getItem('UserInfo')).openid,

                elder:this.$route.query.elder,
                elderName:this.$route.query.elderName,

                title:'',
                carry_time:'',
                carry_time_hide:'',
                desc:'',
                other_staff:'',
                activity_number:0,
                location:'',

                imgList: [], //已上传的图片集合
                imgList2: [], //已上传的图片集合

                body_condition:'健康',
                mental_condition:'好',
                living_condition:'正常',
                social_condition:'从家庭成员得到的支持和照顾',
                demand:'',

                url:encodeURIComponent(location.href.split('#')[0]),

                body_condition_options:[
                    {
                        values: ['健康', '良好','一般','不健康'],
                        className: 'slot1',
                        textAlign: 'center'
                    }
                ],

                mental_condition_options: [{
                    values: ['好', '良好', '较好', '一般','差','较差'],
                    className: 'slot1',
                    textAlign: 'center'
                }],
                living_condition_options: [{
                    values: ['正常', '自理', '半自理', '不能自理'],
                    className: 'slot1',
                    textAlign: 'center'
                }],
                social_condition_options: [{
                    values: ['从家庭成员得到的支持和照顾', '从亲戚朋友得到的支持和照顾', '从邻居得到的支持和照顾'],
                    className: 'slot1',
                    textAlign: 'center'
                }]


            }
        },

        created(){


            let single_type_array = ["入户","电访","医疗","家政","个案工作"];

            if(single_type_array.indexOf(this.$route.query.type)<0){
                this.big_type = 'group';
                this.backurl = '/';
            }

            let type_img =  Object();
            type_img['入户'] = 'care';
            type_img['电访'] = 'phone';
            type_img['医疗'] = 'doctor';
            type_img['家政'] = 'other';
            type_img['便民活动'] = 'bianmin';
            type_img['基础教育'] = 'jiaoyu';
            type_img['康乐活动'] = 'kangle';
            type_img['志愿活动'] = 'zhiyuan';
            type_img['个案工作'] = 'gean';
            type_img['小组工作'] = 'xiaozu';

            this.service_img = type_img[this.$route.query.type];

            if(/iPhone|mac|iPod|iPad/i.test(navigator.userAgent)){
                this.url = encodeURIComponent(sessionStorage.getItem('firstUrl'));
            }


            console.log(sessionStorage.getItem('firstUrl'));
        },



        methods:{
            open (picker) {
                this.carry_time_hide = new Date();
                let that = this;
                setTimeout(function(){
                    that.$refs[picker].open()
                },500)
            },

            changeValue(value) {
                let props = value[0];
                this[props] = value[1];
            },

            handleConfirm (value) {
                let d = new Date(value);

                let the_month = d.getMonth() + 1;
                if(the_month<10){
                    the_month = '0'+the_month;
                }

                let the_day = d.getDate();
                if(the_day<10){
                    the_day = '0'+the_day;
                }

                this.carry_time = d.getFullYear() + '-' + the_month + '-' + the_day + ' ' + d.getHours() + ':' + d.getMinutes() +':' +d.getSeconds();
              //  this.carry_time = moment(value, 'YYYY-MM-DD HH:mm:ss').valueOf();
            },

            handleCancel () {
                this.carry_time_hide = '';
                this.carry_time = '';
            },

            getImageList(files) {
                this.$nextTick(() => {
                    for (let i = 0, len = files.length; i < len; i++) {
                        this.imgList.push(files[i].src.split("base64,")[1]);
                    }
                });
            },
            //删除图片
            removeImage(index) {
                this.imgList.splice(index, 1);
            },

            getImageList2(files) {
                this.$nextTick(() => {
                    for (let i = 0, len = files.length; i < len; i++) {
                        this.imgList2.push(files[i].src.split("base64,")[1]);
                        //上传图片
                        //   this._getFileCode({
                        //     Base64Str: files[i].src.split("base64,")[1],
                        //     AttachmentType: this.$enums.AttachmentType.Activity
                        //   });
                    }
                });
            },
            //删除图片
            removeImage2(index) {
                this.imgList2.splice(index, 1);
            },

            //上传图片获取fileCode (目前该方法没调用，供参考)
            _getFileCode(obj) {
                // Indicator.open(this.lang.dynamic_publishing);
                this.$http
                    .post(this.$profileApi.Shared_UploadImage, obj)
                    .then(data => {
                        if (data.Rstatus) {
                            this.FilecodeList.push(data.Rdata);
                        } else {
                            // Toast(this.lang.dynamic_upload_fail);
                        }
                    })
                    .catch(err => {
                        //   Toast(this.lang.dynamic.dynamic_net_error);
                    });
            },

            updateService(){

                let that = this;

                if (this.title === '' || this.carry_time === '' || this.desc === '' ){
                    this.$toast('带*为必填项，请填写完整');
                    return false;
                }

                if (this.type === '入户' && (this.body_condition === '' || this.mental_condition === '' || this.living_condition === '' || this.social_condition === '' || this.demand === '' || this.imgList.length === 0)){
                    this.$toast('带*为必填项，请填写完整');
                    return false;
                }

                if(this.big_type==='group'&&this.activity_number===''){
                    this.$toast('请输入参与人数');
                    return false;
                }

                this.$indicator.open('加载中');


                this.$axios.post("/serviceRecord", 
                {
                    openid:this.openid,
                    thumb:this.imgList,
                    service:this.service,
                    elder:this.elder,
                    title:this.title,
                    carry_time:this.carry_time,
                    desc:this.desc,
                    activity_number:this.activity_number,
                    activity_photo:this.imgList2,
                    other_staff:this.other_staff,
                    location:this.location,
                    body_condition: this.body_condition,
                    mental_condition: this.mental_condition,
                    living_condition: this.living_condition,
                    social_condition: this.social_condition,
                    demand: this.demand
                })
                    .then(data => {

                        this.$indicator.close();

                        if (data.data.code === 'OK') {
                            this.$toast('打卡成功！');
                            setTimeout(function(){
                                that.$router.push('/');
                            },2000);
                        } else {
                            this.$toast(data.data.message);
                        }
                    });
            },

            getLocation(){
                let that = this;

                this.$axios.get('/getLocation?openid='+this.openid+'&url='+this.url)
                    .then(data => {

                        if (data.data.code === 'OK') {


                            wx.config({
                                debug: false, // 开启调试模式
                                appId: data.data.data.appId, // 必填，公众号的唯一标识
                                timestamp: data.data.data.timestamp, // 必填，生成签名的时间戳
                                nonceStr: data.data.data.nonceStr, // 必填，生成签名的随机串
                                signature: data.data.data.signature, // 必填，签名，见附录1
                                jsApiList: [
                                    'openLocation'
                                ]
                            });

                        } else {
                            this.$toast(data.data.message);
                        }
                    });

                wx.ready((res) => {
                    wx.getLocation({
                        success: function (res) {

                            let pointY = res.latitude; // 纬度，浮点数，范围为90 ~ -90
                            let pointX = res.longitude; // 经度，浮点数，范围为180 ~ -180。


                            that.$axios.get('/getLocationAddress?openid='+that.openid+'&x='+pointX+'&y='+pointY)
                                .then(data => {

                                  //  alert(data.data.data);

                                    if (data.data.code === 'OK') {
                                        that.location = data.data.data;
                                    } else {
                                        that.$toast(data.data.message);
                                    }
                                });
                        },
                        cancel: function (res) {
                            that.$toast('用户拒绝授权定位');
                            that.location = '用户拒绝授权定位';
                        },

                        fail:function(res){
                            console.log('fail',res);
                           // that.$toast(res);
                        }
                    });
                });
            },

        },


        mounted(){
            this.getLocation();
        }

    }
</script>

<style scoped>
    .service-header{
        padding:20px;
    }
    .service-header-info{
        display:flex;
        background:#fff;
        align-items: center;
        padding:10px 0;
        justify-content: center;
        border-radius:10px;
    }

    .service-header-img{
        width:15%;
    }

    .service-header-img img{
        width:100%;
    }


</style>


// WEBPACK FOOTER //
// src/pages/service2.vue